// extracted by mini-css-extract-plugin
module.exports = {"initials":"UserInitials_initials__Go2Ct"};